/**
 * Design Tokens — single source of truth for the design system.
 *
 * These tokens are used by components when Tailwind classes aren't sufficient
 * (e.g., chart colors, programmatic styling, Framer Motion variants).
 *
 * The Tailwind theme in tailwind.config.ts mirrors these values for class-based styling.
 */

export const colors = {
  brand: {
    50:  '#EEF2FF',
    100: '#E0E7FF',
    200: '#C7D2FE',
    300: '#A5B4FC',
    400: '#818CF8',
    500: '#6366F1',
    600: '#4F46E5',
    700: '#4338CA',
    800: '#3730A3',
    900: '#312E81',
  },

  /** Chart color palette — distinct, accessible, ordered by visual weight */
  chart: [
    '#6366F1', // indigo
    '#06B6D4', // cyan
    '#F59E0B', // amber
    '#10B981', // emerald
    '#F43F5E', // rose
    '#8B5CF6', // violet
    '#EC4899', // pink
    '#14B8A6', // teal
    '#F97316', // orange
    '#3B82F6', // blue
    '#84CC16', // lime
    '#EF4444', // red
  ],

  status: {
    success: '#10B981',
    warning: '#F59E0B',
    error:   '#EF4444',
    info:    '#3B82F6',
  },
} as const;

export const spacing = {
  sidebar: {
    expanded: 264,
    collapsed: 72,
  },
  topbar: 56,
  page: {
    paddingX: 32,
    paddingY: 24,
  },
} as const;

export const transitions = {
  /** Fast micro-interactions: hover, focus */
  fast: { duration: 0.15, ease: [0.23, 1, 0.32, 1] },
  /** Normal interactions: open/close, expand */
  normal: { duration: 0.25, ease: [0.23, 1, 0.32, 1] },
  /** Slow/dramatic transitions: page transitions, modals */
  slow: { duration: 0.4, ease: [0.23, 1, 0.32, 1] },
  /** Spring for bouncy elements */
  spring: { type: 'spring' as const, stiffness: 300, damping: 30 },
} as const;
